export function getIndicatorName(indicator) {
  if (!indicator) return undefined;
  return indicator.is_used && indicator.optional_name ? indicator.optional_name : indicator.ind_name_eng;
}
